import { ComponentName } from '@constants';
import { enableModal } from '@state/reducers/modals.ts';
import {
  setDepositThresholdInfo,
  setDisableLogoutModal,
  setLogout,
} from '@state/reducers/user.ts';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketPlayerDepositThresholdWatcher() {
  const { getLatest } = useSocket();
  const dispatch = useDispatch();
  const threshold = getLatest('player_deposit_threshold');

  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (threshold) {
      // @ts-ignore
      const eventKey = `${threshold.action}:${threshold.data?.player_id ?? 'unknown'}`;

      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      // @ts-ignore
      dispatch(setDepositThresholdInfo(threshold.data));
    }
  }, [dispatch, threshold]);

  return null;
}
